export default __webpack_public_path__ + "static/media/sweepstakesSpecialAccess@3x.ad253715.png";